import { ServiceCode } from '../models/service.code.model';

const RESIDENTIAL_SERVICE_CODES = new Set<string>([
  ServiceCode.BulkPickupTownServiceDetailDto,
  ServiceCode.TrashPickUpTownServiceDetailDto,
  ServiceCode.RecyclingTownServiceDetailDto,
  ServiceCode.FoodWasteTownServiceDetailDto,
  ServiceCode.TrashPickUpAndRecyclingTownServiceDetailDto,
]);

export const isResidentialServiceCode = (serviceCode: string | null | undefined): boolean => {
  return Boolean(serviceCode && RESIDENTIAL_SERVICE_CODES.has(serviceCode));
};
